<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.menu_popup">
  <app-popup-header title="{{localService.languageContent.menu_popup.mapped_page_key}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-12">
        <span class="en">{{strPageKey}}&nbsp;({{pageKey}})</span>
        <div style="float:right;">
          <i class="material-icons" (click)="onLoad()">refresh</i>
        </div>
      </div>
    </div>
    <div *ngIf="wrapper.menus.length == 0">
      {{localService.languageContent.menu_popup.no_records}}
    </div>
    <div *ngIf="wrapper.menus.length > 0" style="margin-top:10px;">
      <div *ngFor="let item of wrapper.menus">
        <div class="vertical_menu_parent">
          <i class="material-icons menu_icon">{{item.menu.v3}}</i>
          <span>{{item.menu.v5}}</span>
          <span *ngIf="localService.selected.user != '' && item.menu.v4 == '#UserName#'" class="en">&nbsp;-&nbsp;</span>
          <span *ngIf="localService.selected.user != '' && item.menu.v4 == '#UserName#'" [ngClass]="localService.getLanguageCode(localService.loggedMember.loggedMember.content.v5)">
            {{localService.loggedMember.loggedMember.content.v1}}
          </span>
        </div>
        <div>
          <div *ngFor="let itemSub of item.subMenus">
            <div id="page_key_{{itemSub.menu.key}}" class="vertical_menu_child">
              <i class="material-icons menu_icon">{{itemSub.menu.v3}}</i>
              <span>{{itemSub.menu.v5}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
